import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LegendCont, MeterCont, MeterDesc } from './EffectAverageMeter.styles';
import EffectMeter from './EffectMeter';
import { IEffectAverage } from '../../../../../services/reports';
import {
  Header,
  Wrapper,
} from '../../../SharedEffectReportComponents/EffectReportTemplate/EffectReportTemplate.styles';
import { ThresholdColorBlocks } from '../../../SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/ValueColorBlocks/ValueColorBlocks'; // eslint-disable-line max-len

interface IEffectAverageMeter {
  average: IEffectAverage;
}

const EffectAverageMeter: FC<IEffectAverageMeter> = ({ average }) => {
  const { t } = useTranslation();
  const { average: value, threshold_values } = average;

  return (
    <>
      <Header>{t('report.effect.averageMeter.title')}</Header>
      <Wrapper id="EffectAverageMeterCard">
        <LegendCont>
          <ThresholdColorBlocks
            shape="square"
            direction="row"
            flattened={true}
            thresholdValues={threshold_values}
          />
        </LegendCont>
        <MeterCont>
          <EffectMeter value={value} thresholdValues={threshold_values} />
        </MeterCont>
        <MeterDesc>{t('report.effect.averageMeter.description')}</MeterDesc>
      </Wrapper>
    </>
  );
};

export default EffectAverageMeter;
